<template>
  <div>
    <a @click="open"> 过{{ oks }}个 / 共{{ list.length }}个</a>
    <Drawer v-model="drawer" width="100%">
      <div class="times">
        <div class="timesLeft">
          <div class="top">
            <locus v-if="drawer" ref="locus"></locus>
          </div>
          <div class="bottom">
            <tlist @row="reRow" :tableData="otherData">

            </tlist>
          </div>
        </div>
        <div class="timesRight">
          <Steps class="tujing" direction="vertical">
            <Step :icon="ficon(item)" v-for="(item, index) in list" :key="index">
              <template slot="title">
                {{ item.name }}
              </template>
              <template slot="content">


                <ly-form-item label="进入时间">{{
                  utils.time(item.startTime)
                }}</ly-form-item>
                <ly-form-item label="离开时间">
                  {{ utils.time(item.endTime) }}</ly-form-item>
                <ly-form-item label="停留时长">{{
                  utils.minTime(duration(item.startTime, item.endTime))
                }}</ly-form-item>
              </template>
            </Step>
          </Steps>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
import locus from "../map/locusMap.vue";
import locus20 from "../map20/locusMap.vue";
import tlist from "./tlist.vue";
var vmap = localStorage.getItem('vmap');
export default {
  props: ["data", "title"],
  components: { locus: vmap == 2.0 ? locus20 : locus, tlist },
  data() {
    return {
      drawer: false,
      list: "",
      /* list: [
        {
          isOk: true,
          address: "暂无详细地址",
          name: "双龙河桥西油联加油站",
          time: 1691657597000,
        },
        {
          isOk: false,
          address: "暂无详细地址",
          name: "双龙河桥西油联加油站",
          time: null,
        },
        {
          isOk: false,
          address: "暂无详细地址",
          name: "双龙河桥西油联加油站",
          time: null,
        },
        {
          isOk: true,
          address: "暂无详细地址",
          name: "双龙河桥西油联加油站",
          time: 1691657597000,
        },
      ], */
      oks: 0,
      otherData: []
    };
  },
  methods: {
    ficon(item) {
      if (item.isOk == 1) {
        return "md-checkmark-circle";
      } else if (item.isOk == 2) {
        return "md-log-in";
      } else if (item.isOk == 3) {
        return "md-locate";
      }
      return;
      if (index == 0) {
        return "md-remove";
      } else if (index == this.list.length - 1) {
        return "md-flag";
      } else {
        return "md-arrow-down";
      }
    },

    fnum() {
      var t = this.list;
      this.oks = 0;
      for (let i = 0; i < t.length; i++) {
        if (t[i].startTime != null && t[i].endTime != null) {
          t[i].isOk = 1;
          t[i].icon = "static/ljt1.png";
          this.oks += 1;
        } else if (t[i].startTime != null && t[i].endTime == null) {
          t[i].isOk = 2;
          t[i].icon = "static/ljt2.png";
        } else {
          t[i].isOk = 3;
          t[i].icon = "static/ljt2.png";
        }
      }
    },
    duration(s, t) {
      if (s == null || t == null) {
        return 0;
      } else {
        var r = (t - s) / (1000 * 60);
        return Math.ceil(r);
      }
    },
    open() {
      this.drawer = true;
      console.log(this.list);
      setTimeout(() => {
        //this.$refs.locus.showLjt(this.list);
        
        this.getData();
      }, 500);
    },
    getData() {
      var x = this.data;
      let params = {
        id: x.id,
        returnCoord: 2,
      };
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-trp/times/item",
        data: params,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载

        var data = res.data.data.locusList;

        this.otherData = data;
   
        //如果有轨迹在播放，先销毁

        if (res.data.code == 200) {
          if (data.length >= 1) {
            var lnglat = [];
            for (let i = 0; i < data.length; i++) {

              lnglat.push([data[i].x, data[i].y]);
              //data[i].tms = data[i].gpsTime / 1000;
              data[i].locateLng = data[i].x;
              data[i].locateLat = data[i].y;
              data[i].carNo = x.carNo;
              data[i].deviceNo = x.deviceNo;
              data[i].gpsTime1 = this.utils.time(data[i].gpsTime);
              data[i].accStatus1 = this.$t("accStatus." + data[i].accStatus);
              /* if (data[i].speed == 0) {
                data[i].parkDuration = 5;
              } */

            }

            this.$refs.locus.loadUi(lnglat, data); //渲染轨迹
            this.$refs.locus.showPoints(this.list);
            //this.$refs.locus.showpark(data, 3); //停车点
          } else if (data.length == 0) {
            this.$Message.error("暂无轨迹");
            this.$refs.locus.loadUi([], []); //清空轨迹
            this.$refs.locus.showpark([], 0); //清空停车点
            this.$refs.locus.showPoints(this.list);
            this.$store.state.control = false;
          }
        } else {
          this.$Message.error(res.data.message);
        }
        //var v=res.data.data.po;

        //this.$refs.locus.showLines(v);
      });
    },
    reRow(v) {
      this.$refs.locus.drawPoint(v);
    }
  },
  mounted() {
    this.list = this.data.markerList;
    this.fnum();
  },
  watch: {
    data() {
      this.list = this.data.markerList;
      this.fnum();
    }
  }
};
</script>
<style>
.tujing .ivu-steps-item.ivu-steps-status-wait .ivu-steps-title {
  color: #333;
}

.tujing .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner span,
.tujing .ivu-steps-item.ivu-steps-status-wait .ivu-steps-head-inner>.ivu-steps-icon {
  color: #2d8cf0;
}

.tujing .ivu-steps-item.ivu-steps-status-wait .ivu-steps-content {
  color: #333;
}

.times {
  display: flex;
  width: 100%;
  height: 100%;
}

.timesLeft {
  width: calc(100% - 300px);
  height: 100%;
  background: #ffffff;
}

.timesLeft .top {
  width: 100%;
  height: calc(100% - 200px);
  background: #ccc;
}

.timesLeft .bottom {
  width: 100%;
  height: 200px;
}

.timesRight {
  width: 300px;
  height: 100%;
  overflow: auto;
  padding-left: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/tangci/tujing.vue